import { useState } from "react";
import { ThreeDots } from "react-loader-spinner";

const SearchInput = ({ searchQuery, setSearchQuery, loading, setLoading }) => {
  const handleSearchInputChange = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <div
      className="search-wrapper"
      style={{ position: "relative" }}
    >
      <input
        type="search"
        aria-controls="user-list-table"
        onChange={handleSearchInputChange}
        value={searchQuery}
        className="form-control me-2 w-100"
        placeholder="Search..."
        style={{ paddingRight: "2rem" }}
      />

      {loading && (
        <ThreeDots
          height="20"
          width="20"
          color="#000"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
          }}
        />
      )}
    </div>
  );
};

export default SearchInput;
